const storageConstants = {
  AIRCACHE_PREFIX: 'AIRCACHE',
  SESSION_TYPE: 'SESSION',
  FLIGHT_PRICE_CACHE: 'FLIGHT-PRICE',
  LOCAL_TYPE: 'LOCAL',
  SESSION: (key, value) => {
    sessionStorage.setItem(key, value)
  },
  LOCAL: (key, value) => {
    localStorage.setItem(key, value)
  }
}

export { storageConstants }
